import { useState, useEffect } from 'react';
import axios from 'axios';
import { _basename, ajax_api, shortNum } from '../../Globals';
import RagnaLoader from '../ReactComponents/RagnaLoader';
import moment from 'moment';
import { Helmet } from 'react-helmet';
import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { useOutletContext } from "react-router-dom";
import { NavLink } from "react-router-dom";

function CustomTooltip({ payload, label, active }) {
    if (active) {
        return (
            <div className="custom-tooltip">
                <p className="label">{`${label}: ${payload[0].value} SP Items`}</p>
            </div>
        );
    }

    return null;
}

const Dashboard = props => {
    const [graphData, setGraphData] = useState(); //{ name (month), count}
    const [tblData, setTblData] = useState(); //{items: {Title, EnactedDate}, officials: {Name, Items} }
    const [dashCount, setDashCount] = useState({
        items: "-",
        officials: "-",
        councils: "-",
        committees: "-"
    });

    const [creds, setCreds] = useOutletContext();
    const [authenticated, setAuthenticated] = useState(false);

    const [getDataErrorStates, setGetDataErrorStates] = useState([]);

    const getDashCount = _ => {
        axios.get(`${ajax_api}main/get-dashboard-data/dash-count`).then(r => {
            var d = r.data;
            var item_string = d.items + "";
            setGetDataErrorStates(a => a.filter(aa => aa != "dashCount"));
            setDashCount(
                {
                    ...d,
                    items: shortNum(d.items),
                    total_items: parseInt(item_string).toLocaleString()
                });
        }).catch(e => {
            console.log(`[dash-count] ${e}. Retrying in 20 seconds...`);
            setGetDataErrorStates(a => [...new Set(a)].concat(["dashCount"]));
            setTimeout(getDashCount, 20000);
        });
    }

    const getGraphData = _ => {
        axios.get(`${ajax_api}main/get-dashboard-data/graph`).then(r => {
            setGetDataErrorStates(a => a.filter(aa => aa != "graphData"));
            setGraphData(r.data);
        }).catch(e => {
            console.log(`[graph-data] ${e}. Retrying in 20 seconds...`);
            setGetDataErrorStates(a => [...new Set(a)].concat(["graphData"]));
            setTimeout(getGraphData, 20000);
        });
    }

    const getOfficialsTable = d => {
        axios.get(`${ajax_api}main/get-dashboard-data/officials-table`).then(rr => {
            d = { ...d, officials: rr.data };
            setGetDataErrorStates(a => a.filter(aa => aa != "officialsTable"));
            //setTblData(d);

            getSoleOfficialsTable(d);
        }).catch(e => {
            console.log(`[officials-table] ${e}. Retrying in 20 seconds...`);
            setGetDataErrorStates(a => [...new Set(a)].concat(["officialsTable"]));
            setTimeout(getOfficialsTable(d), 20000);
        });
    }
    const getSoleOfficialsTable = d => {
        axios.get(`${ajax_api}main/get-dashboard-data/sole-officials-table`).then(rr => {
            d = { ...d, soleOfficials: rr.data };
            setGetDataErrorStates(a => a.filter(aa => aa != "soleOfficialsTable"));
            console.log(d);
            setTblData(d);
        }).catch(e => {
            console.log(`[sole-officials-table] ${e}. Retrying in 20 seconds...`);
            setGetDataErrorStates(a => [...new Set(a)].concat(["soleOfficialsTable"]));
            setTimeout(getSoleOfficialsTable(d), 20000);
        });
    }
    const getItemsTable = _ => {
        axios.get(`${ajax_api}main/get-dashboard-data/items-table`).then(r => {
            var d = { items: r.data };
            setGetDataErrorStates(a => a.filter(aa => aa != "itemsTable"));
            getOfficialsTable(d);
        }).catch(e => {
            console.log(`[items-table] ${e}. Retrying in 20 seconds...`);
            setGetDataErrorStates(a => [...new Set(a)].concat(["itemsTable", "officialsTable"]));
            setTimeout(getItemsTable, 20000);
        });
    }

    useEffect(_ => {
        setAuthenticated(creds != null);
    }, [creds])

    //useEffect(_ => {
    //    if (authenticated) {
    //        getDashCount();
    //        getGraphData();
    //        getItemsTable();
    //    }
    //}, [authenticated]);
    useEffect(_ => {
        //if (authenticated) {
            getDashCount();
            getGraphData();
            getItemsTable();
        //}
    }, []);

    const renderLineChart = (
        <ResponsiveContainer width="100%" height="100%">
            <LineChart width={800} height={300} data={graphData ?? null} margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>
                <Line type="monotone" dataKey="count" stroke="#8884d8" />
                <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip content={<CustomTooltip />} />
            </LineChart>
        </ResponsiveContainer>
    );

    return <div className="container-fluid p-0 pb-3">
        <Helmet>
            <title>LTS | Dashboard</title>
        </Helmet>
        <div className="bg-white p-4">
            <div className="px-4 d-flex">
                <img className="d-none d-lg-block d-md-block" src={_basename + "/city-hall.png"}
                    style={{ width: "10vw", height: "10vw" }} />
                <div style={{ flex: 1, textAlign: "center" }}>
                    <h2>City Government of Puerto Princesa</h2>
                    <h3>Legislative Tracking System</h3>
                </div>
                <img className=" d-none d-lg-block d-md-block" src={_basename + "/favicon.png"}
                    style={{ width: "10vw", height: "10vw" }} />
            </div>
            <hr />
            <h5>
                The “Legislative Tracking System” is a software program developed as a tool to track,
                monitor and store communications, requests, proposed resolutions and ordinances, communications,
                Sangguniang Panglungsod Resolutions and ordinances to be acted upon.
            </h5>
            <NavLink to={"/legislations"} className="btn w-100 btn-primary" style={{ fontSize: "calc(12px + 2vw)" }}>
                Browse City Legislations
                <i class="ms-3 fa fa-arrow-right"></i>
            </NavLink>
        </div>
        {
            //authenticated ? 
            <>
                <div className="row mt-3">
                    <div className="col">
                        <div className="card p-2">
                            <div className="d-flex align-items-center justify-content-center">
                                <div className="px-2">
                                    <i className="fa fa-gavel fa-3x" />
                                    <div style={{ fontSize: "0.75em", textAlign: "center" }}>SP Items</div>
                                </div>
                                <div title={dashCount.total_items} style={{ fontSize: "2em" }} className="mx-2">{dashCount.items}</div>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card p-2">
                            <div className="d-flex align-items-center justify-content-center">
                                <div className="px-2">
                                    <i className="fa fa-user-tie fa-3x" />
                                    <div style={{ fontSize: "0.75em", textAlign: "center" }}>Officials</div>
                                </div>
                                <div style={{ fontSize: "2em" }} className="mx-2">{dashCount.officials}</div>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card p-2">
                            <div className="d-flex align-items-center justify-content-center">
                                <div className="px-2">
                                    <i className="fa fa-users fa-3x" />
                                    <div style={{ fontSize: "0.75em", textAlign: "center" }}>Councils</div>
                                </div>
                                <div style={{ fontSize: "2em" }} className="mx-2">{dashCount.councils}</div>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card p-2">
                            <div className="d-flex align-items-center justify-content-center">
                                <div className="px-2">
                                    <i className="fa fa-user-group fa-3x" />
                                    <div style={{ fontSize: "0.75em", textAlign: "center" }}>Committees</div>
                                </div>
                                <div style={{ fontSize: "2em" }} className="mx-2">{dashCount.committees}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col">
                        <div className="card">
                            <div className="card-header">
                                Enacted SP Items last 12 months
                            </div>
                            <div className="card-text p-2" style={{ width: "100%", height: graphData == null ? "auto" : 300 }}>
                                {
                                    <>
                                        {graphData == null ? <>
                                            <RagnaLoader />
                                            {
                                                getDataErrorStates.includes("graphData") ? <div class="text-center">
                                                    Server error. Retrying in 20 seconds.
                                                </div> : ""
                                            }
                                        </> : <></>}
                                        {
                                            renderLineChart
                                        }
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-md-7 mb-2">
                        <div className="card">
                            <div className="card-header">
                                Recently enacted SP Items
                            </div>
                            <div className="card-text p-2">
                                {
                                    tblData == null || tblData.items == null ? <>
                                        <RagnaLoader />
                                        {
                                            getDataErrorStates.includes("itemsTable") ? <div class="text-center">
                                                Server error. Retrying in 20 seconds.
                                            </div> : ""
                                        }
                                    </> :
                                        <table className="table table-sm">
                                            <thead>
                                                <tr>
                                                    <th>Title</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    tblData?.items.length > 0 ? tblData?.items.map(d => <tr>
                                                        <td>{d.Title.length > 120 ? d.Title.substr(0, 150) + "..." : d.Title}</td>
                                                        <td>{moment(d.EnactedDate).format("MM-DD-YY")}</td>
                                                    </tr>)
                                                        : <tr><td colSpan="2" className="text-center">No data found...</td></tr>
                                                }
                                            </tbody>
                                        </table>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="col mb-2">
                        <div className="card">
                            <div className="card-header">
                                Most Items Authored (Sole Author)
                            </div>
                            <div className="card-text p-2">
                                {
                                    tblData == null || tblData.soleOfficials == null ? <>
                                        <RagnaLoader />
                                        {
                                            getDataErrorStates.includes("soleOfficialsTable") ? <div class="text-center">
                                                Server error. Retrying in 20 seconds.
                                            </div> : ""
                                        }
                                    </> :
                                        <table className="table table-sm">
                                            <thead>
                                                <tr>
                                                    <th>Main Author</th>
                                                    <th>Authored</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    tblData?.soleOfficials.length > 0 ? tblData?.soleOfficials.map(o => <tr>
                                                        <td>{o.Name}</td>
                                                        <td>{o.Items}</td>
                                                    </tr>)
                                                        : <tr><td colSpan="2" className="text-center">No data found...</td></tr>
                                                }
                                            </tbody>
                                        </table>
                                }
                            </div>
                        </div>

                        <div className="card mt-2">
                            <div className="card-header">
                                Most Items Authored (Multiple Authors)
                            </div>
                            <div className="card-text p-2">
                                {
                                    tblData == null || tblData.officials == null ? <>
                                        <RagnaLoader />
                                        {
                                            getDataErrorStates.includes("officialsTable") ? <div class="text-center">
                                                Server error. Retrying in 20 seconds.
                                            </div> : ""
                                        }
                                    </> :
                                        <table className="table table-sm">
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Authored</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    tblData?.officials.length > 0 ? tblData?.officials.map(o => <tr>
                                                        <td>{o.Name}</td>
                                                        <td>{o.Items}</td>
                                                    </tr>)
                                                        : <tr><td colSpan="2" className="text-center">No data found...</td></tr>
                                                }
                                            </tbody>
                                        </table>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </> //: <></>
        }
    </div>
}


export default Dashboard;